<template>

     <v-select
        v-model="selectedCustomerType"
        :options="customerTypes"
        :clearable="false"
        placeholder="Select a customer type"
        label="name"
    />

    <input type="hidden" name="type" :value="selectedCustomerType ? selectedCustomerType.id : ''">

    <div v-if="errors.length > 0" >
        <div class="alert alert-danger mt-2" role="alert" v-for="(error, index) in errors" :key="index">
            {{ error }}
        </div>
    </div>

</template>

<script>

import VSelect from 'vue-select';

export default {

    props: {
        // Options come from App\Enums\Movements\CustomerType::options().
        customerTypes: {
            type: Array,
            required: true
        },
        old: {
            type: [String, Number],
            required: false,
            default: null
        },
        errors: {
            type: Array,
            required: false,
            default: () => []
        }
    },

    components: {
        VSelect
    },

    data() {
        return {
            selectedCustomerType: null,
        }
    },

    mounted() {

        this.selectedCustomerType = this.findType(this.old) ?? this.customerTypes[0];

    },

    methods: {

        findType(id) {
            if (id === null || id === '') {
                return null;
            }

            return this.customerTypes.find(type => type.id === Number(id)) ?? null;
        }

    },
}

</script>
